
import carousel from "bootstrap/js/dist/carousel";
import collapse from "bootstrap/js/dist/collapse";
import GLightbox from "glightbox";

document.addEventListener('DOMContentLoaded', function () {

    GLightbox({
        touchNavigation: true,
        loop: true,
    });

}, false);